import configureStore from './configureStore'

export * from './actions'
export * from './reducers'
export * from './configureStore'

const store = configureStore()

export default store
